import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AxiosError, AxiosResponse, AxiosResponseHeaders } from "axios";
import { Thunk } from "../../store";
import {
  BackendIniciarSession,
  getCurrentDomain,
} from "../../../apis/backend/Api";
import { formatearMensajeBackend } from "../../../apis/helper/helperApi";
import {
  setBackendActualizarDisponibilidad,
  setDisponible,
  setDisponibleGuardia,
} from "./actualizarDisponibilidad";
import { setObtenerPonderaciones } from "./ponderacionesUsuarios";
import mock_Json from "../../../dataJson/loginbacked.json";
import { TypeStatus } from "../../helpers/constantes";

export const SET_CURRENT_SESSION = "SET_CURRENT_SESSION";
export const LOGIN_SUCCESS_WITH_SESSION = "LOGIN_SUCCESS_WITH_SESSION";
export const LOGOUT_SESSION = "LOGOUT_SESSION";
interface Permiso {
  Usuario: string;
  Modulo: string;
  Observacion: boolean;
  Insercion: boolean;
  Modificacion: boolean;
  Eliminacion: boolean;
}
interface State {
  loginBackend: any[];
  clientesAdministrados: any[];
  usuariosCliente: any[];
  usuario: any[];
  CategoriaIdCategoria: number;
  Permisos: any[];
  TokenApi: string;
  IdSesion: string;
  IdPerfil: string;
  NombreCliente: string;
  IdCliente: string;
  UsuarioBonitaBackend: string;
  UsuarioBackend: string;
  GuardiaActiva: boolean;
  status: TypeStatus;
  isLoading: boolean;
  Success: boolean;
  CasoSimplificado: boolean;
  SolicitudCargaManual: boolean;
  Disponible: boolean;
  DisponibleGuardia: boolean;
  TipoHorario: string;
  Mensaje: string | null;
  error: string | null;
}

const initialState: State = {
  loginBackend: [],
  clientesAdministrados: [],
  usuariosCliente: [],
  usuario: [],
  CategoriaIdCategoria: 0,
  Permisos: [],
  TokenApi: "",
  IdSesion: "",
  IdPerfil: "",
  IdCliente: "",
  NombreCliente: "",
  GuardiaActiva: false,
  status: "idle",
  isLoading: false,
  Success: false,
  CasoSimplificado: false,
  SolicitudCargaManual: false,
  Mensaje: "",
  error: null,
  UsuarioBonitaBackend: "",
  UsuarioBackend: "",
  Disponible: false,
  DisponibleGuardia: false,
  TipoHorario: "",
};

interface defaultResponse {
  data: any;
  status: number;
  statusText: string;
  headers: AxiosResponseHeaders | {};
  config: any;
  request?: any;
}
const defaultResp: defaultResponse = {
  data: undefined,
  status: 0,
  statusText: "",
  headers: {},
  config: undefined,
};
const loginSlice = createSlice({
  name: "loginBackend",
  initialState,
  reducers: {
    setLoginBackend: (state, action: PayloadAction<any[]>) => {
      state.loginBackend = action.payload;
    },
    setClientesAdministrados: (state, action: PayloadAction<any[]>) => {
      state.clientesAdministrados = action.payload;
    },
    setUsuariosCliente: (state, action: PayloadAction<any[]>) => {
      state.usuariosCliente = action.payload;
    },
    setUsuario: (state, action: PayloadAction<any[]>) => {
      state.usuario = action.payload;
    },
    setPermisos: (state, action: PayloadAction<any[]>) => {
      state.Permisos = action.payload;
    },
    setCategoriaIdCategoria: (state, action: PayloadAction<number>) => {
      state.CategoriaIdCategoria = action.payload;
    },
    setGuardiaActiva: (state, action: PayloadAction<boolean>) => {
      state.GuardiaActiva = action.payload;
    },
    setIdSesion: (state, action: PayloadAction<string>) => {
      state.IdSesion = action.payload;
    },
    setTokenApi: (state, action: PayloadAction<string>) => {
      state.TokenApi = action.payload;
    },
    setNombreCliente: (state, action: PayloadAction<string>) => {
      state.NombreCliente = action.payload;
    },
    setIdPerfil: (state, action: PayloadAction<string>) => {
      state.IdPerfil = action.payload;
    },
    setUsuarioBonitaBackend: (state, action: PayloadAction<string>) => {
      state.UsuarioBonitaBackend = action.payload;
    },
    setUsuarioBackend: (state, action: PayloadAction<string>) => {
      state.UsuarioBackend = action.payload;
    },
    setIdCliente: (state, action: PayloadAction<string>) => {
      state.IdCliente = action.payload;
    },
    getLoginBackend: (state, action: PayloadAction<any[]>) => {
      state.loginBackend = action.payload;
    },
    setClearLoginBackend: (state, action: PayloadAction<any[]>) => {
      state = initialState;
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setStatus: (state, action: PayloadAction<TypeStatus>) => {
      state.status = action.payload;
    },
    setResult: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setSuccess: (state, action: PayloadAction<boolean>) => {
      state.Success = action.payload;
    },
    setCasoSimplificado: (state, action: PayloadAction<boolean>) => {
      state.CasoSimplificado = action.payload;
    },
    setSolicitudCargaManual: (state, action: PayloadAction<boolean>) => {
      state.SolicitudCargaManual = action.payload;
    },
    setDisponibleProfile: (state, action: PayloadAction<boolean>) => {
      state.Disponible = action.payload;
    },
    setDisponibleGuardiaProfile: (state, action: PayloadAction<boolean>) => {
      state.DisponibleGuardia = action.payload;
    },
    setTipoHorario: (state, action: PayloadAction<string>) => {
      state.TipoHorario = action.payload;
    },
    setMensaje: (state, action: PayloadAction<string>) => {
      state.Mensaje = action.payload;
    },
  },
});
//

// Función para agregar datos a sessionStorage
interface SessionData {
  [id: string]: { email: string; telefono: string }[];
}

// Función para agregar datos a sessionStorage
function agregarDatosASession(
  idSession: string,
  email: string,
  telefono: string,
): void {
  // Obtener los datos de sessionStorage
  const sessionData: SessionData = JSON.parse(
    sessionStorage.getItem("session") || "{}",
  );

  // Verificar si ya existe un array de datos para el idSession dado
  if (!sessionData[idSession]) {
    sessionData[idSession] = [];
  }

  // Agregar los datos al array del idSession
  sessionData[idSession].push({ email, telefono });

  // Guardar los datos actualizados en sessionStorage
  sessionStorage.setItem("session", JSON.stringify(sessionData));
}
// Función para obtener datos de sessionStorage por idSession
function obtenerDatosPorId(
  idSession: string,
): { email: string; telefono: string }[] | undefined {
  // Obtener los datos de sessionStorage
  const sessionData: SessionData = JSON.parse(
    sessionStorage.getItem("session") || "{}",
  );

  // Verificar si existe un array de datos para el idSession dado
  if (sessionData[idSession]) {
    return sessionData[idSession];
  }

  return undefined;
}

export const setBackendLogin =
  (username: string, password: string): Thunk =>
  async (dispatch): Promise<AxiosResponse | AxiosError> => {
    let usuariosCliente: any[] = [];
    dispatch(setIsLoading(true));

    try {
      const response: AxiosResponse = await BackendIniciarSession(
        username,
        password,
      );
      const headers = response.headers;

      sessionStorage.setItem("headers", JSON.stringify(headers));
      // Verificar si existen cookies en los encabezados
      if (headers && headers["set-cookie"]) {
        // Las cookies están en el encabezado 'Set-Cookie'
        const cookies = headers["set-cookie"];

        // Aquí podrías guardar las cookies en sessionStorage o utilizarlas de alguna manera
        sessionStorage.setItem("cookies", JSON.stringify(cookies));
      }

      dispatch(
        setUsuarioBonitaBackend(
          String(response.data.Data[0].usuario.UsuarioBonita),
        ),
      );

      dispatch(
        setUsuarioBackend(String(response.data.Data[0].usuario.usuario)),
      );

      dispatch(
        setGuardiaActiva(Boolean(response.data.Data[0].usuario.GuardiaActiva)),
      );
      const isDisponible = Boolean(response.data.Data[0].usuario.Disponible);
      const isDisponibleGuardia = Boolean(
        response.data.Data[0].usuario.DisponibleGuardia,
      );

      dispatch(setDisponibleProfile(isDisponible));
      dispatch(setDisponibleGuardiaProfile(isDisponibleGuardia));
      dispatch(setDisponible(isDisponible));
      dispatch(setDisponibleGuardia(isDisponibleGuardia));

      dispatch(
        setTipoHorario(String(response.data.Data[0].usuario.TipoHorario)),
      );
      dispatch(setPermisos(response.data.Data[0].usuario.Permisos));
      dispatch(
        setCategoriaIdCategoria(
          Number(response.data.Data[0].usuario.categoria.IdCategoria),
        ),
      );
      dispatch(
        setNombreCliente(
          String(response.data.Data[0].usuario.cliente.NombreCliente),
        ),
      );
      dispatch(
        setIdPerfil(String(response.data.Data[0].usuario.perfil.IdPerfil)),
      );
      const puedeInsertarTicketSimplificado: boolean = (
        response.data.Data?.[0]?.usuario?.Permisos ?? []
      ).some(
        (permiso: Permiso) =>
          permiso.Modulo === "Ticket Simplificado" &&
          permiso.Insercion === true,
      );

      dispatch(setCasoSimplificado(puedeInsertarTicketSimplificado));

      const puedeInsertarSolicitudCargaManual: boolean = (
        response.data.Data?.[0]?.usuario?.Permisos ?? []
      ).some(
        (permiso: Permiso) =>
          permiso.Modulo === "Solicitud Carga Manual" &&
          permiso.Insercion === true,
      );

      dispatch(setSolicitudCargaManual(puedeInsertarSolicitudCargaManual));
      dispatch(setSuccess(response.data.Success));
      dispatch(setMensaje(formatearMensajeBackend(response.data.Mensaje)));
      dispatch(setLoginBackend(response.data.Data));
      dispatch(setUsuario(response.data.Data[0].usuario));
      dispatch(setIsLoading(false));

      const isError =
        response.data?.Success === false ||
        (response.data?.ResultadoSolicitud !== undefined &&
          response.data?.ResultadoSolicitud !== 200);

      if (isError) {
        dispatch(setIsLoading(false));
        dispatch(setStatus("failed"));
        dispatch(setSuccess(false));
      } else {
        if (response.data.Data[0].usuario.perfil.IdPerfil === 3) {
          for (
            let i = 0;
            i < response.data.Data[0].usuario.ClientesAdministrados.length;
            i++
          ) {
            const cliente =
              response.data.Data[0].usuario.ClientesAdministrados[i];
            usuariosCliente.push(cliente.UsuariosBonita);
          }
          dispatch(setUsuariosCliente(usuariosCliente));
        }

        if (response.data.Data[0].usuario.perfil.IdPerfil === 3) {
          dispatch(
            setClientesAdministrados(
              response.data.Data[0].usuario.ClientesAdministrados,
            ),
          );
        }
        if (response.data.Data[0].usuario.perfil.IdPerfil === 2) {
          for (
            let i = 0;
            i < response.data.Data[0].usuario.ClientesAdministrados.length;
            i++
          ) {
            const cliente =
              response.data.Data[0].usuario.ClientesAdministrados[i];
            usuariosCliente.push(cliente.UsuariosBonita);
          }
          dispatch(setUsuariosCliente(usuariosCliente));
        }
        if (response.data.Data[0].usuario.perfil.IdPerfil === 2) {
          dispatch(
            setClientesAdministrados(
              response.data.Data[0].usuario.ClientesAdministrados,
            ),
          );
        }

        if (response.data.Data[0].usuario.perfil.IdPerfil === 4) {
          for (
            let i = 0;
            i < response.data.Data[0].usuario.ClientesAdministrados.length;
            i++
          ) {
            const cliente =
              response.data.Data[0].usuario.ClientesAdministrados[i];
            usuariosCliente.push(cliente.UsuariosBonita);
          }
          dispatch(setUsuariosCliente(usuariosCliente));
        }
        if (response.data.Data[0].usuario.perfil.IdPerfil === 4) {
          dispatch(
            setClientesAdministrados(
              response.data.Data[0].usuario.ClientesAdministrados,
            ),
          );
        }
        if (response.data.Data[0].usuario.perfil.IdPerfil === 7) {
          for (
            let i = 0;
            i < response.data.Data[0].usuario.ClientesAdministrados.length;
            i++
          ) {
            const cliente =
              response.data.Data[0].usuario.ClientesAdministrados[i];
            usuariosCliente.push(cliente.UsuariosBonita);
          }
          dispatch(setUsuariosCliente(usuariosCliente));
        }

        if (response.data.Data[0].usuario.perfil.IdPerfil === 7) {
          dispatch(
            setClientesAdministrados(
              response.data.Data[0].usuario.ClientesAdministrados,
            ),
          );
        }
        dispatch(setStatus("succeeded"));
        dispatch(setSuccess(true));
        dispatch(setLoginBackend(response.data.Data));
        dispatch(setUsuario(response.data.Data[0].usuario));
        dispatch(
          setNombreCliente(
            String(response.data.Data[0].usuario.cliente.NombreCliente),
          ),
        );
        dispatch(
          setIdPerfil(String(response.data.Data[0].usuario.perfil.IdPerfil)),
        );

        const puedeInsertarTicketSimplificado: boolean = (
          response.data.Data?.[0]?.usuario?.Permisos ?? []
        ).some(
          (permiso: Permiso) =>
            permiso.Modulo === "Ticket Simplificado" &&
            permiso.Insercion === true,
        );

        dispatch(setCasoSimplificado(puedeInsertarTicketSimplificado));

        const puedeInsertarSolicitudCargaManual: boolean = (
          response.data.Data?.[0]?.usuario?.Permisos ?? []
        ).some(
          (permiso: Permiso) =>
            permiso.Modulo === "Solicitud Carga Manual" &&
            permiso.Insercion === true,
        );

        dispatch(setSolicitudCargaManual(puedeInsertarSolicitudCargaManual));
        dispatch(
          setIdCliente(String(response.data.Data[0].usuario.cliente.IdCliente)),
        );
        dispatch(setIdSesion(String(response.data.Data[0].IdSesion)));

        dispatch(setTokenApi(String(response.data.Data[0].TokenApi)));

        await localStorage.setItem("IdSesion", response.data.Data[0].IdSesion);
        await localStorage.setItem("TokenApi", response.data.Data[0].TokenApi);
        await localStorage.setItem("authenticated", "true");

        // Automatización: Obtener ponderaciones del usuario logueado
        let diaActual = new Date().getDay();
        let diaInicio = diaActual;
        let diaFin = diaActual;

        if (diaActual >= 1 && diaActual <= 5) {
          diaInicio = 1;
          diaFin = 5;
        } else if (diaActual === 6) {
          diaInicio = 6;
          diaFin = 6;
        } else if (diaActual === 0) {
          diaInicio = 0;
          diaFin = 0;
        }

        dispatch(
          setObtenerPonderaciones({
            Usuario: String(response.data.Data[0].usuario.usuario),
            DiaInicio: diaInicio,
            DiaFin: diaFin,
          }),
        );
      }

      dispatch(setMensaje(formatearMensajeBackend(response.data.Mensaje)));

      return response.data;
    } catch (error: any) {
      dispatch(setIsLoading(false));
      dispatch(setSuccess(false));
      dispatch(setStatus("failed"));

      if (error.response?.status === 401) {
        dispatch(setStatus("noAutorice"));
        dispatch(
          setMensaje(
            formatearMensajeBackend(
              "Tu sesión ha expirado. Vuelve a iniciar sesión",
            ),
          ),
        );
      } else if (error.response) {
        // Hay respuesta del servidor, pero es otro error (400, 422, 500, etc.)
        console.error(
          "Error de servidor:",
          error.response.status,
          error.response.data,
        );

        const errorData = error.response.data;
        const mensajeBackend = errorData?.Mensaje;
        const resultadoSolicitud = errorData?.ResultadoSolicitud;

        if (
          mensajeBackend &&
          (resultadoSolicitud !== 200 || errorData?.Success === false)
        ) {
          dispatch(setMensaje(formatearMensajeBackend(mensajeBackend)));
        } else {
          dispatch(
            setMensaje(
              `Error ${error.response.status}: Ocurrió un problema en el servidor.`,
            ),
          );
        }
      } else if (error.request) {
        console.error("Error de conexión:", error.message);
        dispatch(
          setMensaje(
            "No se pudo conectar al servidor. Por favor, revisa tu conexión a internet o tu VPN.",
          ),
        );
      } else {
        console.error("Error de red o solicitud:", error.message);
        dispatch(
          setMensaje(
            "Ocurrió un problema con la red. Por favor, verifica tu conexión.",
          ),
        );
      }
      return error as AxiosError;
    } finally {
      dispatch(setIsLoading(false));

      if (getCurrentDomain() === "localhost") {
        let response: AxiosResponse = defaultResp;
        response.data = mock_Json;
        const headers = response.headers;
        sessionStorage.setItem("headers", JSON.stringify(headers));
        // Verificar si existen cookies en los encabezados
        if (headers && headers["set-cookie"]) {
          // Las cookies están en el encabezado 'Set-Cookie'
          const cookies = headers["set-cookie"];

          // Aquí podrías guardar las cookies en sessionStorage o utilizarlas de alguna manera
          sessionStorage.setItem("cookies", JSON.stringify(cookies));
        }

        dispatch(
          setUsuarioBonitaBackend(
            String(response.data.Data[0].usuario.UsuarioBonita),
          ),
        );

        dispatch(
          setUsuarioBackend(String(response.data.Data[0].usuario.usuario)),
        );

        dispatch(
          setGuardiaActiva(
            Boolean(response.data.Data[0].usuario.GuardiaActiva),
          ),
        );

        dispatch(
          setDisponibleProfile(
            Boolean(response.data.Data[0].usuario.Disponible),
          ),
        );
        dispatch(
          setDisponibleGuardiaProfile(
            Boolean(response.data.Data[0].usuario.DisponibleGuardia),
          ),
        );
        // Actualizar también la disponibilidad global (importada)
        dispatch(
          setDisponible(Boolean(response.data.Data[0].usuario.Disponible)),
        );
        dispatch(
          setDisponibleGuardia(
            Boolean(response.data.Data[0].usuario.DisponibleGuardia),
          ),
        );
        dispatch(
          setTipoHorario(String(response.data.Data[0].usuario.TipoHorario)),
        );
        dispatch(setPermisos(response.data.Data[0].usuario.Permisos));
        dispatch(
          setCategoriaIdCategoria(
            Number(response.data.Data[0].usuario.categoria.IdCategoria),
          ),
        );
        dispatch(
          setNombreCliente(
            String(response.data.Data[0].usuario.cliente.NombreCliente),
          ),
        );
        dispatch(
          setIdPerfil(String(response.data.Data[0].usuario.perfil.IdPerfil)),
        );

        const puedeInsertarTicketSimplificado: boolean = (
          response.data.Data?.[0]?.usuario?.Permisos ?? []
        ).some(
          (permiso: Permiso) =>
            permiso.Modulo === "Ticket Simplificado" &&
            permiso.Insercion === true,
        );

        dispatch(setCasoSimplificado(puedeInsertarTicketSimplificado));

        const puedeInsertarSolicitudCargaManual: boolean = (
          response.data.Data?.[0]?.usuario?.Permisos ?? []
        ).some(
          (permiso: Permiso) =>
            permiso.Modulo === "Solicitud Carga Manual" &&
            permiso.Insercion === true,
        );

        dispatch(setSolicitudCargaManual(puedeInsertarSolicitudCargaManual));
        dispatch(setSuccess(response.data.Success));
        dispatch(setMensaje(formatearMensajeBackend(response.data.Mensaje)));
        dispatch(setLoginBackend(response.data.Data));
        dispatch(setUsuario(response.data.Data[0].usuario));

        dispatch(setIsLoading(false));

        if (response.data.Success) {
          if (response.data.Data[0].usuario.perfil.IdPerfil === 3) {
            for (
              let i = 0;
              i < response.data.Data[0].usuario.ClientesAdministrados.length;
              i++
            ) {
              const cliente =
                response.data.Data[0].usuario.ClientesAdministrados[i];
              usuariosCliente.push(cliente.UsuariosBonita);
            }
            dispatch(setUsuariosCliente(usuariosCliente));
          }

          if (response.data.Data[0].usuario.perfil.IdPerfil === 3) {
            dispatch(
              setClientesAdministrados(
                response.data.Data[0].usuario.ClientesAdministrados,
              ),
            );
          }
          if (response.data.Data[0].usuario.perfil.IdPerfil === 2) {
            for (
              let i = 0;
              i < response.data.Data[0].usuario.ClientesAdministrados.length;
              i++
            ) {
              const cliente =
                response.data.Data[0].usuario.ClientesAdministrados[i];
              usuariosCliente.push(cliente.UsuariosBonita);
            }
            dispatch(setUsuariosCliente(usuariosCliente));
          }
          if (response.data.Data[0].usuario.perfil.IdPerfil === 2) {
            dispatch(
              setClientesAdministrados(
                response.data.Data[0].usuario.ClientesAdministrados,
              ),
            );
          }

          if (response.data.Data[0].usuario.perfil.IdPerfil === 4) {
            for (
              let i = 0;
              i < response.data.Data[0].usuario.ClientesAdministrados.length;
              i++
            ) {
              const cliente =
                response.data.Data[0].usuario.ClientesAdministrados[i];
              usuariosCliente.push(cliente.UsuariosBonita);
            }
            dispatch(setUsuariosCliente(usuariosCliente));
          }
          if (response.data.Data[0].usuario.perfil.IdPerfil === 4) {
            dispatch(
              setClientesAdministrados(
                response.data.Data[0].usuario.ClientesAdministrados,
              ),
            );
          }
          if (response.data.Data[0].usuario.perfil.IdPerfil === 7) {
            for (
              let i = 0;
              i < response.data.Data[0].usuario.ClientesAdministrados.length;
              i++
            ) {
              const cliente =
                response.data.Data[0].usuario.ClientesAdministrados[i];
              usuariosCliente.push(cliente.UsuariosBonita);
            }
            dispatch(setUsuariosCliente(usuariosCliente));
          }

          if (response.data.Data[0].usuario.perfil.IdPerfil === 7) {
            dispatch(
              setClientesAdministrados(
                response.data.Data[0].usuario.ClientesAdministrados,
              ),
            );
          }
          dispatch(setStatus("succeeded"));
          dispatch(setLoginBackend(response.data.Data));
          dispatch(setUsuario(response.data.Data[0].usuario));
          dispatch(
            setNombreCliente(
              String(response.data.Data[0].usuario.cliente.NombreCliente),
            ),
          );
          dispatch(
            setIdPerfil(String(response.data.Data[0].usuario.perfil.IdPerfil)),
          );
          dispatch(
            setTipoHorario(String(response.data.Data[0].usuario.TipoHorario)),
          );

          const puedeInsertarTicketSimplificado: boolean = (
            response.data.Data?.[0]?.usuario?.Permisos ?? []
          ).some(
            (permiso: Permiso) =>
              permiso.Modulo === "Ticket Simplificado" &&
              permiso.Insercion === true,
          );

          dispatch(setCasoSimplificado(puedeInsertarTicketSimplificado));

          const puedeInsertarSolicitudCargaManual: boolean = (
            response.data.Data?.[0]?.usuario?.Permisos ?? []
          ).some(
            (permiso: Permiso) =>
              permiso.Modulo === "Solicitud Carga Manual" &&
              permiso.Insercion === true,
          );

          dispatch(setSolicitudCargaManual(puedeInsertarSolicitudCargaManual));
          dispatch(
            setIdCliente(
              String(response.data.Data[0].usuario.cliente.IdCliente),
            ),
          );

          dispatch(setIdSesion(String(response.data.Data[0].IdSesion)));

          dispatch(setTokenApi(String(response.data.Data[0].TokenApi)));

          await localStorage.setItem(
            "IdSesion",
            response.data.Data[0].IdSesion,
          );
          await localStorage.setItem(
            "TokenApi",
            response.data.Data[0].TokenApi,
          );
          await localStorage.setItem("authenticated", "true");

          // Automatización (Mock): Obtener ponderaciones del usuario logueado
          let diaActual = new Date().getDay();
          let diaInicio = diaActual;
          let diaFin = diaActual;

          if (diaActual >= 1 && diaActual <= 5) {
            diaInicio = 1;
            diaFin = 5;
          } else if (diaActual === 6) {
            diaInicio = 6;
            diaFin = 6;
          } else if (diaActual === 0) {
            diaInicio = 0;
            diaFin = 0;
          }

          dispatch(
            setObtenerPonderaciones({
              Usuario: String(response.data.Data[0].usuario.usuario),
              DiaInicio: diaInicio,
              DiaFin: diaFin,
            }),
          );
        }

        const mockData: any = mock_Json;
        const isErrorMock =
          mockData?.Success === false ||
          (mockData?.ResultadoSolicitud !== undefined &&
            mockData?.ResultadoSolicitud !== 200);

        if (isErrorMock) {
          dispatch(setIsLoading(false));
          dispatch(setStatus("failed"));
          dispatch(setSuccess(false));
        } else {
          dispatch(setStatus("succeeded"));
          dispatch(setSuccess(true));
        }
        dispatch(setMensaje(formatearMensajeBackend(response.data.Mensaje)));

        return response.data;
      }
    }
  };
//
export const setBackendLogOut =
  (IdPerfil: string): Thunk =>
  async (dispatch): Promise<AxiosResponse | AxiosError> => {
    dispatch(setIsLoading(true));
    const authenticated = localStorage.getItem("authenticated")
      ? Boolean(localStorage.getItem("authenticated"))
      : false;
    try {
      if (IdPerfil === "2" && authenticated === true) {
        await dispatch(setBackendActualizarDisponibilidad(false, false));
      }

      let response: AxiosResponse = defaultResp;
      sessionStorage.clear();
      sessionStorage.setItem("authenticated", "false");
      sessionStorage.removeItem("authenticated");
      sessionStorage.removeItem("user");
      sessionStorage.removeItem("persist:root");
      sessionStorage.removeItem("persist");
      sessionStorage.removeItem("root");

      localStorage.removeItem("IdSesion");
      localStorage.removeItem("TokenApi");
      localStorage.removeItem("authenticated");
      localStorage.removeItem("pestaña_actividad_global");
      localStorage.removeItem("sync_close_modal_timestamp");

      dispatch(setClearLoginBackend([]));
      dispatch(setLoginBackend([]));
      dispatch(setClientesAdministrados([]));
      dispatch(setUsuariosCliente([]));
      dispatch(setUsuario([]));
      dispatch(setCategoriaIdCategoria(0));
      dispatch(setGuardiaActiva(false));
      dispatch(setTokenApi(""));
      dispatch(setIdSesion(""));
      dispatch(setUsuarioBonitaBackend(""));
      dispatch(setUsuarioBackend(""));
      dispatch(setPermisos([]));
      dispatch(setIsLoading(false));
      dispatch(setCasoSimplificado(false));
      dispatch(setSolicitudCargaManual(false));
      dispatch(setDisponible(false));
      dispatch(setDisponibleGuardia(false));
      dispatch(setTipoHorario(""));
      dispatch(setStatus("idle"));
      return response.data;
    } catch (error: any) {
      dispatch(setIsLoading(false));
      dispatch(setStatus("failed"));
      if (error.response?.status === 401) {
        dispatch(setStatus("noAutorice"));
        dispatch(
          setMensaje(
            formatearMensajeBackend(
              "Tu sesión ha expirado. Vuelve a iniciar sesión",
            ),
          ),
        );
      } else if (error.response) {
        // Hay respuesta del servidor, pero es otro error (400, 500, etc.)
        console.error(
          "Error de servidor:",
          error.response.status,
          error.response.data,
        );
        dispatch(
          setMensaje(
            `Error ${error.response.status}: Ocurrió un problema en el servidor.`,
          ),
        );
      } else if (error.request) {
        // La solicitud fue enviada, pero no hubo respuesta
        console.error("Error de conexión:", error.message);
        dispatch(
          setMensaje(
            "No se pudo conectar al servidor. Por favor, revisa tu conexión a internet o tu VPN.",
          ),
        );
      } else {
        // Es un error de red (DNS, etc.) o un error de configuración de la solicitud
        console.error("Error de red o solicitud:", error.message);
        dispatch(
          setMensaje(
            "Ocurrió un problema con la red. Por favor, verifica tu conexión.",
          ),
        );
      }
      return error as AxiosError;
    } finally {
      dispatch(setIsLoading(false));

      if (getCurrentDomain() === "localhost") {
        let response: AxiosResponse = defaultResp;
        sessionStorage.clear();
        sessionStorage.setItem("authenticated", "false");
        sessionStorage.removeItem("authenticated");
        sessionStorage.removeItem("user");
        sessionStorage.removeItem("persist:root");
        sessionStorage.removeItem("persist");
        sessionStorage.removeItem("root");

        localStorage.removeItem("IdSesion");
        localStorage.removeItem("TokenApi");
        localStorage.removeItem("authenticated");

        dispatch(setClearLoginBackend([]));
        dispatch(setLoginBackend([]));
        dispatch(setClientesAdministrados([]));
        dispatch(setUsuariosCliente([]));
        dispatch(setUsuario([]));
        dispatch(setCategoriaIdCategoria(0));
        dispatch(setGuardiaActiva(false));
        dispatch(setTokenApi(""));
        dispatch(setIdSesion(""));
        dispatch(setUsuarioBonitaBackend(""));
        dispatch(setUsuarioBackend(""));
        dispatch(setPermisos([]));
        dispatch(setIsLoading(false));
        dispatch(setCasoSimplificado(false));
        dispatch(setSolicitudCargaManual(false));
        dispatch(setDisponible(false));
        dispatch(setDisponibleGuardia(false));
        dispatch(setTipoHorario(""));
        dispatch(setStatus("idle"));
        return response.data;
      }
    }
  };

export const setBackendClearLogOut =
  (): Thunk =>
  async (dispatch): Promise<AxiosResponse | AxiosError> => {
    dispatch(setIsLoading(true));

    try {
      let response: AxiosResponse = defaultResp;
      sessionStorage.clear();
      sessionStorage.setItem("authenticated", "false");
      sessionStorage.removeItem("authenticated");
      sessionStorage.removeItem("user");
      sessionStorage.removeItem("persist:root");
      sessionStorage.removeItem("persist");
      sessionStorage.removeItem("root");
      localStorage.removeItem("IdSesion");
      localStorage.removeItem("TokenApi");
      localStorage.removeItem("authenticated");
      localStorage.removeItem("user");
      localStorage.removeItem("persist:root");
      localStorage.removeItem("persist");
      localStorage.removeItem("root");
      //sessionStorage.clear();
      dispatch(setClearLoginBackend([]));
      dispatch(setLoginBackend([]));
      dispatch(setClientesAdministrados([]));
      dispatch(setUsuariosCliente([]));
      dispatch(setUsuario([]));
      dispatch(setCategoriaIdCategoria(0));
      dispatch(setGuardiaActiva(false));
      dispatch(setTokenApi(""));
      dispatch(setIdSesion(""));
      dispatch(setUsuarioBonitaBackend(""));
      dispatch(setUsuarioBackend(""));
      dispatch(setPermisos([]));
      dispatch(setIsLoading(false));
      dispatch(setCasoSimplificado(false));
      dispatch(setSolicitudCargaManual(false));
      dispatch(setStatus("idle"));
      dispatch(setDisponible(false));
      dispatch(setDisponibleGuardia(false));
      dispatch(setTipoHorario(""));
      dispatch(setStatus("idle"));
      return response.data;
    } catch (error: any) {
      dispatch(setIsLoading(false));
      dispatch(setStatus("failed"));

      return error as AxiosError;
    } finally {
      dispatch(setIsLoading(false));
      if (getCurrentDomain() === "localhost") {
        let response: AxiosResponse = defaultResp;
        sessionStorage.clear();
        sessionStorage.setItem("authenticated", "false");
        sessionStorage.removeItem("authenticated");
        sessionStorage.removeItem("user");
        sessionStorage.removeItem("persist:root");
        sessionStorage.removeItem("persist");
        sessionStorage.removeItem("root");
        localStorage.removeItem("IdSesion");
        localStorage.removeItem("TokenApi");
        localStorage.removeItem("authenticated");
        dispatch(setClearLoginBackend([]));
        dispatch(setLoginBackend([]));
        dispatch(setClientesAdministrados([]));
        dispatch(setUsuariosCliente([]));
        dispatch(setUsuario([]));
        dispatch(setCategoriaIdCategoria(0));
        dispatch(setGuardiaActiva(false));
        dispatch(setTokenApi(""));
        dispatch(setIdSesion(""));
        dispatch(setUsuarioBonitaBackend(""));
        dispatch(setUsuarioBackend(""));
        dispatch(setPermisos([]));
        dispatch(setIsLoading(false));
        dispatch(setCasoSimplificado(false));
        dispatch(setSolicitudCargaManual(false));
        dispatch(setStatus("idle"));
        dispatch(setDisponible(false));
        dispatch(setDisponibleGuardia(false));
        dispatch(setStatus("idle"));
        return response.data;
      }
    }
  };
export const {
  setLoginBackend,
  setClientesAdministrados,
  setUsuariosCliente,
  setUsuario,
  setPermisos,
  setGuardiaActiva,
  setCategoriaIdCategoria,
  setTokenApi,
  setIdSesion,
  setIdPerfil,
  setNombreCliente,
  setUsuarioBonitaBackend,
  setUsuarioBackend,
  setIdCliente,
  getLoginBackend,
  setClearLoginBackend,
  setIsLoading,
  setStatus,
  setResult,
  setCasoSimplificado,
  setSolicitudCargaManual,
  setSuccess,
  setMensaje,
  setTipoHorario,
  setDisponibleProfile,
  setDisponibleGuardiaProfile,
} = loginSlice.actions;

export default loginSlice.reducer;
